<template>
  <div>
    <div class="title">{{ `${$t('management.editOrganisationTitle')} ${model.OrganisationName}` }}</div>
    <div class="row" style="margin-left: 1rem">
      <div class="col s4">
        <div class="row">
          <div class="col s12"><h6>{{ $t('management.companyDetails') }}</h6></div>
        </div>
        <div class="row">
          <div class="col s3 label">{{ $t('management.companyName') }}</div>
          <div class="col s9">
            <input type="text" class="browser-default" v-model="company.name" />
          </div>
        </div>
        <div class="row">
          <div class="col s3 label">{{ $t('management.companyURL') }}</div>
          <div class="col s9">
            <input type="text" class="browser-default" v-model="company.url" />
          </div>
        </div>
        <div class="row">
          <div class="col s3 label">{{ $t('management.companyTheme') }}</div>
          <div class="col s9">
            <input type="text" class="browser-default" v-model="company.theme" />
          </div>
        </div>
<!--        <div class="row">-->
<!--          <div class="col s3 label">Blocked</div>-->
<!--          <div class="col s9">-->
<!--            <input type="checkbox" v-model="company.blocked" />-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="col s4">
        <div class="row">
          <div class="col s12"><h6>{{ $t('management.locationDetails') }}</h6></div>
        </div>
        <div class="row">
          <div class="col s3 label">{{ $t('management.companyAddress') }}</div>
          <div class="col s9">
            <input type="text" class="browser-default" v-model="location.address" />
          </div>
        </div>
        <div class="row">
          <div class="col s3 label">{{ $t('management.companyCity') }}</div>
          <div class="col s9">
            <input type="text" class="browser-default" v-model="location.city" />
          </div>
        </div>
        <div class="row">
          <div class="col s3 label">{{ $t('management.companyPostalCode') }}</div>
          <div class="col s9">
            <input type="text" class="browser-default" v-model="location.postalCode" />
          </div>
        </div>
        <div class="row">
          <div class="col s3 label">{{ $t('management.companyEmail') }}</div>
          <div class="col s9">
            <input type="text" class="browser-default" v-model="location.email" />
          </div>
        </div>
        <div class="row">
          <div class="col s3 label">{{ $t('management.companyPhone') }}</div>
          <div class="col s9">
            <input type="text" class="browser-default" v-model="location.phone" />
          </div>
        </div>
      </div>
      <div class="col s4">
        <div class="row">
          <div class="col s12"><h6>{{ $t('management.contactDetails') }}</h6></div>
        </div>
        <div class="row">
          <div class="col s3 label">{{ $t('management.contactName') }}</div>
          <div class="col s9">
            <input type="text" class="browser-default" v-model="contact.name" />
          </div>
        </div>
        <div class="row">
          <div class="col s3 label">{{ $t('management.contactPhone') }}</div>
          <div class="col s9">
            <input type="text" class="browser-default" v-model="contact.phone" />
          </div>
        </div>
        <div class="row">
          <div class="col s3 label">{{ $t('management.contactEmail') }}</div>
          <div class="col s9">
            <input type="text" class="browser-default" v-model="contact.email" />
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="organisation !== null">
      <div class="col s12 right-align">
        <button
          type="button"
          class="waves-effect waves-light btn blue"
          style="margin: 0 1rem 1rem 0"
          @click="save"
        >
          {{ $t('management.save') }}
        </button>
        <button
          type="button"
          class="waves-effect btn"
          style="background-color: #9e9e9e; margin: 0 8rem 1rem 0"
          @click="reset"
        >
          {{ $t('management.reset') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import organisationApi from '../../../services/api/OrganisationsApi'

export default {
  name: 'Organisations',
  components: {},
  props: {
    model: {
      required: true
    },
    cancelFn: {
      required: true
    }
  },
  data () {
    return {
      organisations: [],
      company: {},
      location: {},
      contact: {}
    }
  },
  computed: {},
  watch: {
    organisation () {
      this.prepareEdit()
    }
  },
  mounted () {
    this.prepareEdit()
  },
  methods: {
    async reset () {
      this.prepareEdit()
      this.cancelFn()
    },
    async save () {
      const org = {
        OrganisationName: this.company.name,
        Blocked: !!this.company.blocked,
        Adress: this.location.address,
        City: this.location.city,
        PostalCode: this.location.postalCode,
        TelefoonNumber: this.location.phone,
        EmailAdress: this.location.email,
        CompanyUrl: this.company.url,
        ServiceContactName: this.contact.name,
        ServiceTelefoneNumber: this.contact.phone,
        ServiceEmailAdress: this.contact.email,
        Theme: this.company.theme
      }
      await organisationApi.editOrganisation(this.model.OrganisationId, org)
      this.cancelFn()
    },
    prepareEdit () {
      this.company = {
        name: this.model.OrganisationName,
        url: this.model.CompanyUrl,
        theme: this.model.Theme,
        blocked: this.model.blocked
      }
      this.location = {
        address: this.model.Address,
        city: this.model.City,
        postalCode: this.model.PostalCode,
        email: this.model.EmailAdress,
        phone: this.model.TelefoonNumber
      }
      this.contact = {
        name: this.model.ServiceContactName,
        phone: this.model.ServiceTelefoneNumber,
        email: this.model.ServiceEmailAdress
      }
    }
  }
}
</script>

<style scoped>
  .title {
    font-size: x-large;
    font-weight: bold;
    padding: 1rem
  }
  .label {
    font-weight: bold;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/usermanagement/organisations/OrganisationEdit.vue